import React from 'react';
import type { CustomHtmlConfig } from './types';

interface CustomHtmlEmbedProps {
  config: CustomHtmlConfig;
}

export const CustomHtmlEmbed: React.FC<CustomHtmlEmbedProps> = ({ config }) => {
  if (!config.html) return null;

  // In production, you should use DOMPurify or similar to sanitize HTML
  // For now, we'll use dangerouslySetInnerHTML with a warning
  const combinedHtml = `
    ${config.css ? `<style>${config.css}</style>` : ''}
    ${config.html}
    ${config.javascript ? `<script>${config.javascript}</script>` : ''}
  `;

  return <div className="custom-html-embed" dangerouslySetInnerHTML={{ __html: combinedHtml }} />;
};
